/**
 * Product Page Script
 * @description Importa e inicializa funcionalidades específicas da página de produto
 * @version 2.0.0
 * @author Irroba Platform
 */

// Importar módulos globais
import { initGlobalComponents } from '../modules/global-components.js';
import { initProductListsNearViewport } from '../modules/product_list_module.js';
// Importar sistema de zoom de produto
import '../functions/product-zoom.js';
// Importar sistema de compre junto
import BuyTogether from '../functions/buy-together.js';

/**
 * Inicialização da página de produto
 */
const initProductPage = () => {
    // Inicializar módulos globais
    initGlobalComponents();
    initProductListsNearViewport();

    // Funcionalidades específicas do produto
    initProductFeatures();

    // Inicializar Buy Together
    initBuyTogether();

};

/**
 * Funcionalidades específicas da página de produto
 */
const initProductFeatures = () => {
    // Seleção de variação de produto
    initProductVariations();

    // Botão de adicionar ao carrinho
    initAddToCart();

    // Zoom nas imagens
    initImageZoom();

    // Abas de informações
    initProductTabs();

    // Rolagem para o bloco de reviews
    initReviewScroll();

    // Quantidade de produto
    initQuantityControls();
};

/**
 * Inicializa o comportamento de scroll para o bloco de reviews
 */
const initReviewScroll = () => {
    const $reviewTriggers = $('[data-review-scroll]');

    if ($reviewTriggers.length === 0) {
        return;
    }

    $reviewTriggers.on('click', function () {
        const $reviewModule = $('.reviewModule').first();

        if ($reviewModule.length === 0) {
            return;
        }

        $('html, body').animate({ scrollTop: $reviewModule.offset().top }, 1);
    });
};

/**
 * Inicializa variações de produto (cores, tamanhos, etc.)
 */
const initProductVariations = () => {
    const variationSelectors = document.querySelectorAll('[data-variation-select]');

    variationSelectors.forEach(selector => {
        selector.addEventListener('change', function () {
            const selectedValue = this.value;
            const variationType = this.dataset.variationSelect;

            // Atualizar preço, imagem, disponibilidade, etc.
            updateProductVariation(variationType, selectedValue);
        });
    });
};

/**
 * Atualiza produto com base na variação selecionada
 */
const updateProductVariation = (type, value) => {
    // Implementar lógica de atualização de variação

    // Exemplo: atualizar preço
    // Exemplo: atualizar imagem principal
    // Exemplo: verificar disponibilidade
};

/**
 * Inicializa botão de adicionar ao carrinho
 */
const initAddToCart = () => {
    const addToCartBtn = document.querySelector('[data-add-to-cart]');

    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const productId = this.dataset.productId;
            const quantity = document.querySelector('[data-product-quantity]')?.value || 1;

            // Mostrar loading
            showAddToCartLoading();

            // Fazer requisição AJAX
            addProductToCart(productId, quantity);
        });
    }
};

/**
 * Adiciona produto ao carrinho via AJAX
 */
const addProductToCart = (productId, quantity) => {
    // Implementar lógica de adicionar ao carrinho

    // Exemplo de requisição
    /*
    fetch('/index.php?route=checkout/cart/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            product_id: productId,
            quantity: quantity
        })
    })
    .then(response => response.json())
    .then(data => {
        hideAddToCartLoading();
        showAddToCartSuccess();
    })
    .catch(error => {
        hideAddToCartLoading();
        showAddToCartError();
    });
    */
};

/**
 * Mostra loading no botão de adicionar ao carrinho
 */
const showAddToCartLoading = () => {
    const btn = document.querySelector('[data-add-to-cart]');
    if (btn) {
        btn.disabled = true;
        btn.classList.add('loading');
        btn.innerHTML = '<span class="spinner"></span> Adicionando...';
    }
};

/**
 * Remove loading do botão
 */
const hideAddToCartLoading = () => {
    const btn = document.querySelector('[data-add-to-cart]');
    if (btn) {
        btn.disabled = false;
        btn.classList.remove('loading');
        btn.innerHTML = 'Adicionar ao Carrinho';
    }
};

/**
 * Mostra mensagem de sucesso
 */
const showAddToCartSuccess = () => {
    // Implementar notificação de sucesso
};

/**
 * Mostra mensagem de erro
 */
const showAddToCartError = () => {
    console.error('❌ Erro ao adicionar produto');
    alert('Erro ao adicionar produto ao carrinho. Tente novamente.');
};

/**
 * Inicializa zoom nas imagens do produto
 */
const initImageZoom = () => {
    const $productImages = $('.swiper-zoom-container');
    const $zoomContainer = $('.dialog-box-image-zoom');

    if ($productImages.length === 0 || $zoomContainer.length === 0) {
        return;
    }

    $productImages.on('click', function () {
        if (typeof openDialogZoom === 'function') {
            openDialogZoom();
        }
    });
};

/**
 * Inicializa abas de informações do produto
 */
const initProductTabs = () => {
    const tabButtons = document.querySelectorAll('[data-product-tab]');
    const tabContents = document.querySelectorAll('[data-product-tab-content]');

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {
            const targetTab = this.dataset.productTab;

            // Remove active de todos
            tabButtons.forEach(btn => btn.classList.remove('active'));
            tabContents.forEach(content => content.classList.remove('active'));

            // Adiciona active no clicado
            this.classList.add('active');
            const targetContent = document.querySelector(`[data-product-tab-content="${targetTab}"]`);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });
};

/**
 * Inicializa controles de quantidade
 */
const initQuantityControls = () => {
    const quantityInput = document.querySelector('[data-product-quantity]');
    const decreaseBtn = document.querySelector('[data-quantity-decrease]');
    const increaseBtn = document.querySelector('[data-quantity-increase]');

    if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
            if (quantityInput) {
                let currentValue = parseInt(quantityInput.value) || 1;
                if (currentValue > 1) {
                    quantityInput.value = currentValue - 1;
                }
            }
        });
    }

    if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
            if (quantityInput) {
                let currentValue = parseInt(quantityInput.value) || 1;
                const maxQuantity = parseInt(quantityInput.max) || 999;
                if (currentValue < maxQuantity) {
                    quantityInput.value = currentValue + 1;
                }
            }
        });
    }
};

/**
 * Inicializa o sistema Buy Together (Compre Junto)
 */
const initBuyTogether = () => {
    // Verificar se existem elementos buy-together na página
    const buyTogetherContainer = document.querySelector('.buy-together-items-content');
    
    if (!buyTogetherContainer) {
        return;
    }

    // Contar quantos produtos tem no buy together
    const buyTogetherCount = document.querySelectorAll('.buy-together').length;
    
    // Verificar se deve mostrar o total
    const showTotal = document.querySelector('.buy-together-btn-content .price') !== null;
    
    // Verificar se a posição é lateral
    const isPositionSide = buyTogetherContainer.closest('.buy-together-position-side') !== null;

    // Inicializar o Buy Together com as configurações
    BuyTogether.init({
        buyTogetherCount: buyTogetherCount,
        showTotal: showTotal,
        isPositionSide: isPositionSide
    });

    // Expor funções globalmente para compatibilidade com código legado
    if (typeof window !== 'undefined') {
        window.productsBuyTogether = BuyTogether.productsBuyTogether;
        window.btProductOption = BuyTogether.btProductOption;
        window.calculateBtTotal = BuyTogether.calculateBtTotal;
        window.addBuyTogetherToCart = BuyTogether.addBuyTogetherToCart;
        window.parcel = BuyTogether.parcel;
    }
};

/**
 * Inicializa quando o DOM estiver pronto
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
} else {
    initProductPage();
    console.log('DOM já carregado, inicializando página de produto...');
}

/**
 * Exporta para uso global (se necessário)
 */
export default {
    init: initProductPage,
    addToCart: addProductToCart,
    updateVariation: updateProductVariation,
    buyTogether: BuyTogether
};
